import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { CrudType, IApplicationResponse, ModulesBasedApiSuffix, PERMISSION_RESTRICTION_ERROR, PermissionTypes, ResponseMessageTypes, SnackbarService, currentComponentPageBasedPermissionsSelector$, getPDropdownData, prepareGetRequestHttpParams } from '@app/shared';
import { CrudService, RxjsService } from '@app/shared/services';
import { CUSTOMER_COMPONENT } from '@modules/customer';
import { loggedInUserData, selectStaticEagerLoadingTicketStatusState$ } from '@modules/others';
import { UserLogin } from '@modules/others/models';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { take } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { CustomerTicketAddEditComponent } from './customer-ticket-add-edit.component';
@Component({
  selector: 'app-customer-ticket-list',
  templateUrl: './customer-ticket-list.component.html',
  styleUrls: ['./customer-ticket.scss']
})
export class CustomerTicketListComponent extends PrimeNgTableVariablesModel implements OnInit {
  addressId;
  partitionId;
  permission;
  applicationResponse: IApplicationResponse;
  loggedUser: UserLogin;
  id: string;
  customerId: string;
  customerLeadsAddress = "customer leads address";
  ticketStatuses = [];
  ticketSubscription: any;
  ticketQuerySubscription: any;

  constructor(private router: Router, private store: Store<AppState>, public dialogService: DialogService,
    private crudService: CrudService, private rxjsService: RxjsService, private dialog: MatDialog,
    private snackbarService: SnackbarService, private activatedRoute: ActivatedRoute) {
    super();
    this.primengTableConfigProperties = {
      tableCaption: "Customer Ticketing",
      shouldShowBreadCrumb: false,
      selectedTabIndex: 0,
      breadCrumbItems: [{ displayName: 'Customers', relativeRouterUrl: '' }, { displayName: 'Ticket List' }],
      tableComponentConfigs: {
        tabsList: [
          {
            caption: "Customer Ticketing",
            dataKey: 'templateId',
            enableBreadCrumb: false,
            enableAction: true,
            enableClearfix: true,
            enableAddActionBtn: true,
            enableReset: false,
            enableGlobalSearch: false,
            reorderableColumns: false,
            resizableColumns: false,
            enableScrollable: true,
            checkBox: false,
            enableFieldsSearch: true,
            enableHyperLink: true,
            cursorLinkIndex: 0,
            columns: [{ field: 'ticketRefNo', header: 'Ticket ID' },
            { field: 'ticketTypeName', header: 'Action Type' },
            { field: 'usergroupName', header: 'User Group' },
            { field: 'assignedToName', header: 'Assigned To' },
            { field: 'createdDate', header: 'Created Date', isDateTime: true },
            { field: 'lapsedTime', header: 'Lapsed Time' },
            { field: 'ticketStatusName', header: 'Status', type: 'dropdown', options: [] }],
            shouldShowDeleteActionBtn: true,
            shouldShowCreateActionBtn: true,
            areCheckboxesRequired: true,
            isDateWithTimeRequired: true,
            apiSuffixModel: SalesModuleApiSuffixModels.TICKETS,
            moduleName: ModulesBasedApiSuffix.TECHNICIAN,
          }]
      }
    }
    this.combineLatestNgrxStoreData();
    this.id = this.loggedUser.userId;
    this.ticketQuerySubscription = this.activatedRoute.queryParamMap.subscribe((response: any) => {
      if (response && this.activatedRoute.snapshot.queryParams.navigateTab == 8) {
        this.customerId = response?.params?.customerId || '';
        this.addressId = response?.params?.addressId || '';
        this.partitionId = response?.params?.partitionId || '';
        this.getTicketList();
      } else {
        setTimeout(() => {
          this.rxjsService.setGlobalLoaderProperty(false);
        }, 500);
      }
    })
  }

  ngOnInit(): void {
  }

  onActionSubmited(e: any) {
    if (e.data && !e.search && !e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data);
    } else if (e.data && e.search && !e?.col) {
      this.onCRUDRequested(e.type, e.data, e.search);
    } else if (e.type && !e.data && !e?.col) {
      this.onCRUDRequested(e.type, {});
    } else if (e.type && e.data && e?.col?.toString()) {
      this.onCRUDRequested(e.type, e.data, e?.col);
    }
  }

  combineLatestNgrxStoreData() {
    combineLatest([this.store.select(selectStaticEagerLoadingTicketStatusState$),
    this.store.select(loggedInUserData),
    this.store.select(currentComponentPageBasedPermissionsSelector$),
    ]).pipe(take(1)).subscribe((response) => {
      this.ticketStatuses = response[0];
      this.loggedUser = response[1];
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].columns[6].options = getPDropdownData(response[0], 'displayName', 'displayName');
      this.permission = response[2][CUSTOMER_COMPONENT.CUSTOMER]?.find(el => el?.menuName == CUSTOMER_COMPONENT.CUSTOMER_DASHBOARD)?.subMenu?.find(el => el?.menuName?.toLowerCase() == CUSTOMER_COMPONENT.TICKETING);
    });
  }

  getTicketList(pageIndex?: string, pageSize?: string, otherParams?: object) {
    if (this.ticketSubscription && !this.ticketSubscription?.closed) {
      this.ticketSubscription?.unsubscribe();
      this.rxjsService.setGlobalLoaderProperty(false);
    }
    this.rxjsService.setGlobalLoaderProperty(true);
    this.ticketSubscription = this.crudService.get(
      ModulesBasedApiSuffix.SALES,
      SalesModuleApiSuffixModels.TICKETS,
      undefined,
      false,
      prepareGetRequestHttpParams(pageIndex, pageSize, {
        customerId: this.customerId,
        addressId: this.addressId,
        ...otherParams
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.statusCode === 200 && response.resources) {
          this.dataList = response.resources;
          this.dataList.forEach(ele => {
            ele.isUpdateFlag = false;
          });
          this.totalRecords = response.totalCount;
          this.rxjsService.setGlobalLoaderProperty(false);
        }
        this.reset = false;
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  openTicketModal() {
    this.rxjsService.setDialogOpenProperty(true);
    
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    const dialogReff = this.dialogService.open(CustomerTicketAddEditComponent, { 
      baseZIndex: 1000, 
      width: '750px', 
      showHeader: false, 
      data: { 
        custId: this.customerId, 
        addressId: this.addressId,
        fromComponent: currentQueryParams['fromComponent'] // Pass the fromComponent parameter
      } 
    });
    dialogReff.onClose.subscribe(result => {
      if (result) {
        this.router.navigate(['/customer/manage-customers/ticket/view'], { 
          queryParams: { 
            id: result?.ticketId, 
            customerId: this.customerId, 
            addressId: this.addressId, 
            fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
          } 
        });
        return;
      }
    });
  }

  onCRUDRequested(type: CrudType | string, row?: object | any, unknownVar?: any) {
    switch (type) {
      case CrudType.CREATE:
        if (!this.permission?.subMenu?.find(el => el?.menuName == PermissionTypes.ADD)) {
          return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
        }
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        switch (this.selectedTabIndex) {
          case 0:
            this.row = row ? row : { pageIndex: 0, pageSize: 10 };
            this.first = row?.pageIndex && row?.pageSize ? row["pageIndex"] * row["pageSize"] : 0;
            if (unknownVar?.ticketStatusName) {
              unknownVar.ticketStatusId = this.ticketStatuses?.find(tS => tS['displayName'] === unknownVar?.ticketStatusName)?.id;
            }
            this.getTicketList(row["pageIndex"], row["pageSize"], unknownVar);
            break;
        }
        break;
      case CrudType.VIEW:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string) {
    // Get the current query parameters to preserve fromComponent
    const currentQueryParams = this.activatedRoute.snapshot.queryParams;
    
    switch (type) {
      case CrudType.CREATE:
        this.openTicketModal();
        break;
      case CrudType.VIEW:
        this.router.navigate(['/customer/manage-customers/ticket/view'], { 
          queryParams: { 
            id: editableObject['ticketId'], 
            customerId: editableObject['customerId'], 
            addressId: this.addressId, 
            ticketgroupid: editableObject['ticketGroupId'], 
            fromComponent: currentQueryParams['fromComponent'] // Preserve the fromComponent parameter
          } 
        });
        break;
    }
  }

  ngOnDestory() {
    if (this.ticketSubscription) {
      this.ticketSubscription?.unsubscribe();
    }
    if (this.ticketQuerySubscription) {
      this.ticketQuerySubscription?.unsubscribe();
    }
  }
}
